"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getAbstract_1 = __importDefault(require("./getAbstract"));
var luna_object_viewer_1 = __importStar(require("luna-object-viewer"));
var isObj_1 = __importDefault(require("licia/isObj"));
var isStr_1 = __importDefault(require("licia/isStr"));
var isErr_1 = __importDefault(require("licia/isErr"));
var isPrimitive_1 = __importDefault(require("licia/isPrimitive"));
var defaults_1 = __importDefault(require("licia/defaults"));
var isEl_1 = __importDefault(require("licia/isEl"));
var toStr_1 = __importDefault(require("licia/toStr"));
var toNum_1 = __importDefault(require("licia/toNum"));
var toInt_1 = __importDefault(require("licia/toInt"));
var escape_1 = __importDefault(require("licia/escape"));
var isNull_1 = __importDefault(require("licia/isNull"));
var isUndef_1 = __importDefault(require("licia/isUndef"));
var isFn_1 = __importDefault(require("licia/isFn"));
var toArr_1 = __importDefault(require("licia/toArr"));
var isArr_1 = __importDefault(require("licia/isArr"));
var unique_1 = __importDefault(require("licia/unique"));
var contain_1 = __importDefault(require("licia/contain"));
var isEmpty_1 = __importDefault(require("licia/isEmpty"));
var clone_1 = __importDefault(require("licia/clone"));
var noop_1 = __importDefault(require("licia/noop"));
var each_1 = __importDefault(require("licia/each"));
var trim_1 = __importDefault(require("licia/trim"));
var lowerCase_1 = __importDefault(require("licia/lowerCase"));
var keys_1 = __importDefault(require("licia/keys"));
var _1 = __importDefault(require("licia/$"));
var h_1 = __importDefault(require("licia/h"));
var Emitter_1 = __importDefault(require("licia/Emitter"));
var stringifyAll_1 = __importDefault(require("licia/stringifyAll"));
var nextTick_1 = __importDefault(require("licia/nextTick"));
var linkify_1 = __importDefault(require("licia/linkify"));
var highlight_1 = __importDefault(require("licia/highlight"));
var util_1 = require("./util");
var stripIndent_1 = __importDefault(require("licia/stripIndent"));
var regJsUrl = /https?:\/\/([0-9.\-A-Za-z]+)(?::(\d+))?\/[A-Z.a-z0-9/]*\.js/g;
var emptyHighlightStyle = {
    comment: '',
    string: '',
    number: '',
    keyword: '',
    operator: '',
};
var Log = (function (_super) {
    __extends(Log, _super);
    function Log(console, _a) {
        var _b = _a.type, type = _b === void 0 ? 'log' : _b, _c = _a.args, args = _c === void 0 ? [] : _c, id = _a.id, group = _a.group, targetGroup = _a.targetGroup, header = _a.header, _d = _a.ignoreFilter, ignoreFilter = _d === void 0 ? false : _d, accessGetter = _a.accessGetter, unenumerable = _a.unenumerable, lazyEvaluation = _a.lazyEvaluation;
        var _this = _super.call(this) || this;
        _this.container = (0, h_1.default)('div');
        _this.count = 1;
        _this.width = 0;
        _this.height = 0;
        _this.console = console;
        _this.type = type;
        _this.group = group;
        _this.targetGroup = targetGroup;
        _this.args = args;
        _this.id = id;
        _this.header = header;
        _this.ignoreFilter = ignoreFilter;
        _this.collapsed = false;
        _this.container.log = _this;
        _this.height = 0;
        _this.width = 0;
        _this.$container = (0, _1.default)(_this.container);
        _this.accessGetter = accessGetter;
        _this.unenumerable = unenumerable;
        _this.lazyEvaluation = lazyEvaluation;
        _this.formatMsg();
        if (_this.group) {
            _this.checkGroup();
        }
        return _this;
    }
    Log.prototype.checkGroup = function () {
        var group = this.group;
        var collapsed = false;
        while (group) {
            if (group.collapsed) {
                collapsed = true;
                break;
            }
            group = group.parent;
        }
        if (collapsed !== this.collapsed) {
            this.collapsed = collapsed;
            return true;
        }
        return false;
    };
    Log.prototype.updateIcon = function (icon) {
        var c = this.console.c;
        var $icon = this.$container.find(c('.icon'));
        $icon.rmAttr('class').addClass([c('icon'), c("icon-".concat(icon))]);
        return this;
    };
    Log.prototype.addCount = function () {
        this.count++;
        var _a = this, $container = _a.$container, count = _a.count;
        var c = this.console.c;
        var $countContainer = $container.find(c('.count-container'));
        var $icon = $container.find(c('.icon-container'));
        var $count = $countContainer.find(c('.count'));
        if (count === 2) {
            $countContainer.rmClass(c('hidden'));
        }
        $count.text((0, toStr_1.default)(count));
        $icon.addClass(c('hidden'));
        return this;
    };
    Log.prototype.groupEnd = function () {
        var $container = this.$container;
        var c = this.console.c;
        var $lastNesting = $container
            .find(".".concat(c('nesting-level'), ":not(.").concat(c('group-closed'), ")"))
            .last();
        $lastNesting.addClass(c('group-closed'));
        return this;
    };
    Log.prototype.updateTime = function (time) {
        var $timeContainer = this.$container.find(this.console.c('.time-container'));
        if (this.header) {
            $timeContainer.find('span').eq(0).text(time);
            this.header.time = time;
        }
        return this;
    };
    Log.prototype.isAttached = function () {
        return !!this.container.parentNode;
    };
    Log.prototype.updateSize = function (silent) {
        if (silent === void 0) { silent = true; }
        var _a = this.container.getBoundingClientRect(), width = _a.width, height = _a.height;
        if (this.height !== height || this.width !== width) {
            this.height = height;
            this.width = width;
            if (!silent)
                this.emit('updateSize');
        }
    };
    Log.prototype.html = function () {
        return this.container.outerHTML;
    };
    Log.prototype.text = function () {
        return this.content.textContent || '';
    };
    Log.prototype.needSrc = function () {
        var _a = this, type = _a.type, args = _a.args;
        if (type === 'html')
            return false;
        for (var i = 0, len = args.length; i < len; i++) {
            if ((0, isObj_1.default)(args[i]))
                return true;
        }
        return false;
    };
    Log.prototype.extractObj = function (cb) {
        var _this = this;
        if (cb === void 0) { cb = noop_1.default; }
        var _a = this, args = _a.args, type = _a.type;
        var setSrc = function (result) {
            _this.src = result;
            cb();
        };
        if (type === 'table') {
            this._extractObj(args[0], {}, setSrc);
        }
        else {
            this._extractObj(args.length === 1 && (0, isObj_1.default)(args[0]) ? args[0] : args, {}, setSrc);
        }
    };
    Log.prototype._extractObj = function (obj, options, cb) {
        if (options === void 0) { options = {}; }
        var _a = this, accessGetter = _a.accessGetter, unenumerable = _a.unenumerable;
        (0, defaults_1.default)(options, {
            accessGetter: accessGetter,
            unenumerable: unenumerable,
            symbol: unenumerable,
            timeout: 1000,
        });
        stringify(obj, options, function (result) { return cb(JSON.parse(result)); });
    };
    Log.prototype.click = function () {
        var _this = this;
        var _a = this, type = _a.type, src = _a.src, $container = _a.$container, console = _a.console, unenumerable = _a.unenumerable, accessGetter = _a.accessGetter;
        var c = console.c;
        var args = this.args;
        switch (type) {
            case 'log':
            case 'warn':
            case 'debug':
            case 'output':
            case 'table':
            case 'dir':
            case 'group':
            case 'groupCollapsed':
                if (src || args) {
                    var $json = $container.find(c('.json'));
                    if ($json.hasClass(c('hidden'))) {
                        if ($json.data('init') !== 'true') {
                            if (src) {
                                var staticViewer = new luna_object_viewer_1.Static($json.get(0));
                                staticViewer.set(src);
                                staticViewer.on('change', function () { return _this.updateSize(false); });
                            }
                            else {
                                if (type === 'table' || args.length === 1) {
                                    if ((0, isObj_1.default)(args[0]))
                                        args = args[0];
                                }
                                var objViewer = new luna_object_viewer_1.default($json.get(0), {
                                    unenumerable: unenumerable,
                                    accessGetter: accessGetter,
                                });
                                objViewer.set(args);
                                objViewer.on('change', function () { return _this.updateSize(false); });
                            }
                            $json.data('init', 'true');
                        }
                        $json.rmClass(c('hidden'));
                    }
                    else {
                        $json.addClass(c('hidden'));
                    }
                }
                else if (type === 'group' || type === 'groupCollapsed') {
                    console.toggleGroup(this);
                }
                break;
            case 'error':
                $container.find(c('.stack')).toggleClass(c('hidden'));
                break;
        }
        this.updateSize(false);
    };
    Log.prototype.formatMsg = function () {
        var args = this.args;
        var _a = this, type = _a.type, id = _a.id, header = _a.header, group = _a.group, lazyEvaluation = _a.lazyEvaluation;
        var c = this.console.c;
        args = (0, clone_1.default)(args);
        if (this.needSrc() && !lazyEvaluation) {
            this.extractObj();
        }
        var msg = '';
        var icon;
        var err;
        if (type === 'group' || type === 'groupCollapsed') {
            if (args.length === 0) {
                args = ['console.group'];
            }
        }
        switch (type) {
            case 'log':
                msg = this.formatCommon(args);
                break;
            case 'debug':
                msg = this.formatCommon(args);
                break;
            case 'dir':
                msg = this.formatDir(args);
                break;
            case 'warn':
                icon = 'warn';
                msg = this.formatCommon(args);
                break;
            case 'error':
                if ((0, isStr_1.default)(args[0]) && args.length !== 1)
                    args = this.substituteStr(args);
                err = args[0];
                icon = 'error';
                err = (0, isErr_1.default)(err) ? err : new Error(this.formatCommon(args));
                this.src = err;
                msg = this.formatErr(err);
                break;
            case 'table':
                msg = this.formatTable(args);
                break;
            case 'html':
                msg = args[0];
                break;
            case 'input':
                msg = this.formatJs(args[0]);
                icon = 'input';
                break;
            case 'output':
                msg = this.formatCommon(args);
                icon = 'output';
                break;
            case 'groupCollapsed':
                msg = this.formatCommon(args);
                icon = 'caret-right';
                break;
            case 'group':
                msg = this.formatCommon(args);
                icon = 'caret-down';
                break;
        }
        if (!this.needSrc() || !lazyEvaluation) {
            delete this.args;
        }
        if (type !== 'error' && !this.args) {
            msg = (0, linkify_1.default)(msg, function (url) {
                return "<a href=\"".concat(url, "\" target=\"_blank\">").concat(url, "</a>");
            });
        }
        msg = this.render({ msg: msg, type: type, icon: icon, id: id, header: header, group: group });
        this.$container.addClass("".concat(c('log-container'))).html(msg);
        this.$content = this.$container.find(c('.log-content'));
        this.content = this.$content.get(0);
    };
    Log.prototype.render = function (data) {
        var c = this.console.c;
        var html = '';
        var indent = '';
        if (data.group) {
            var indentLevel = data.group.indentLevel;
            for (var i = 0; i < indentLevel; i++) {
                indent += "<div class=\"".concat(c('nesting-level'), "\"></div>");
            }
        }
        if (data.header) {
            html += (0, stripIndent_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      <div class=\"", "\">\n        ", "\n        <div class=\"", "\">\n          <span>", "</span> <span>", "</span>\n        </div>\n      </div>"], ["\n      <div class=\"", "\">\n        ", "\n        <div class=\"", "\">\n          <span>", "</span> <span>", "</span>\n        </div>\n      </div>"])), c('header'), indent, c('time-from-container'), data.header.time, data.header.from);
        }
        var icon = '';
        if (data.icon) {
            icon = "<div class=\"".concat(c('icon-container'), "\"><span class=\"").concat(c('icon icon-' + data.icon), "\"></span></div>");
        }
        html += "\n    <div class=\"".concat(c(data.type + ' log-item'), "\">\n      ").concat(indent, "\n      ").concat(icon, "\n      <div class=\"").concat(c('count-container hidden'), "\">\n        <div class=\"").concat(c('count'), "\"></div>\n      </div>    \n      <div class=\"").concat(c('log-content-wrapper'), "\">\n        <div class=\"").concat(c('log-content'), "\">").concat(data.msg, "</div>\n      </div>\n    </div>");
        return html;
    };
    Log.prototype.formatTable = function (args) {
        var _this = this;
        var Value = '__LunaConsoleValue';
        var table = args[0];
        var ret = '';
        var filter = args[1];
        var columns = [];
        if ((0, isStr_1.default)(filter))
            filter = (0, toArr_1.default)(filter);
        if (!(0, isArr_1.default)(filter))
            filter = null;
        if (!(0, isObj_1.default)(table))
            return this.formatCommon(args);
        (0, each_1.default)(table, function (val) {
            if ((0, isPrimitive_1.default)(val)) {
                columns.push(Value);
            }
            else if ((0, isObj_1.default)(val)) {
                columns = columns.concat((0, keys_1.default)(val));
            }
        });
        columns = (0, unique_1.default)(columns);
        columns.sort();
        if (filter)
            columns = columns.filter(function (val) { return (0, contain_1.default)(filter, val); });
        if (columns.length > 20)
            columns = columns.slice(0, 20);
        if ((0, isEmpty_1.default)(columns))
            return this.formatCommon(args);
        ret += '<table><thead><tr><th>(index)</th>';
        columns.forEach(function (val) { return (ret += "<th>".concat(val === Value ? 'Value' : (0, toStr_1.default)(val), "</th>")); });
        ret += '</tr></thead><tbody>';
        (0, each_1.default)(table, function (obj, idx) {
            ret += "<tr><td>".concat(idx, "</td>");
            columns.forEach(function (column) {
                if ((0, isObj_1.default)(obj)) {
                    ret +=
                        column === Value
                            ? '<td></td>'
                            : "<td>".concat(_this.formatTableVal(obj[column]), "</td>");
                }
                else if ((0, isPrimitive_1.default)(obj)) {
                    ret +=
                        column === Value
                            ? "<td>".concat(_this.formatTableVal(obj), "</td>")
                            : '<td></td>';
                }
            });
            ret += '</tr>';
        });
        ret += '</tbody></table>';
        ret += "<div class=\"".concat(this.console.c('json hidden'), "\"></div>");
        return ret;
    };
    Log.prototype.formatErr = function (err) {
        var lines = err.stack ? err.stack.split('\n') : [];
        var msg = "".concat(err.message || lines[0], "<br/>");
        lines = lines.map(function (val) { return (0, escape_1.default)(val); });
        var stack = "<div class=\"".concat(this.console.c('stack hidden'), "\">").concat(lines
            .slice(1)
            .join('<br/>'), "</div>");
        return (msg +
            stack.replace(regJsUrl, function (match) { return "<a href=\"".concat(match, "\" target=\"_blank\">").concat(match, "</a>"); }));
    };
    Log.prototype.formatCommon = function (args, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.htmlForEl, htmlForEl = _c === void 0 ? true : _c;
        var needStrSubstitution = (0, isStr_1.default)(args[0]) && args.length !== 1;
        if (needStrSubstitution)
            args = this.substituteStr(args);
        for (var i = 0, len = args.length; i < len; i++) {
            var val = args[i];
            if ((0, isEl_1.default)(val) && htmlForEl) {
                args[i] = this.formatEl(val);
            }
            else if ((0, isFn_1.default)(val)) {
                args[i] = this.formatFn(val);
            }
            else if ((0, isObj_1.default)(val)) {
                args[i] = this.formatObj(val);
            }
            else if ((0, isUndef_1.default)(val)) {
                args[i] = 'undefined';
            }
            else if ((0, isNull_1.default)(val)) {
                args[i] = 'null';
            }
            else {
                val = (0, toStr_1.default)(val);
                if (i !== 0 || !needStrSubstitution)
                    val = (0, escape_1.default)(val);
                args[i] = val;
            }
        }
        return (args.join(' ') + "<div class=\"".concat(this.console.c('json hidden'), "\"></div>"));
    };
    Log.prototype.formatDir = function (args) {
        return this.formatCommon(args, { htmlForEl: false });
    };
    Log.prototype.formatTableVal = function (val) {
        if ((0, isObj_1.default)(val))
            return (val = '{…}');
        if ((0, isPrimitive_1.default)(val))
            return this.getAbstract(val);
        return (0, toStr_1.default)(val);
    };
    Log.prototype.getAbstract = function (obj) {
        return ("<span class=\"".concat(this.console.c('abstract'), "\">") +
            (0, getAbstract_1.default)(obj, {
                getterVal: this.accessGetter,
                unenumerable: false,
            }) +
            '</span>');
    };
    Log.prototype.substituteStr = function (args) {
        var str = (0, escape_1.default)(args[0]);
        var isInCss = false;
        var newStr = '';
        args.shift();
        for (var i = 0, len = str.length; i < len; i++) {
            var c = str[i];
            if (c === '%' && args.length !== 0) {
                i++;
                var arg = args.shift();
                switch (str[i]) {
                    case 'i':
                    case 'd':
                        newStr += (0, toInt_1.default)(arg);
                        break;
                    case 'f':
                        newStr += (0, toNum_1.default)(arg);
                        break;
                    case 's':
                        newStr += (0, toStr_1.default)(arg);
                        break;
                    case 'O':
                        if ((0, isObj_1.default)(arg)) {
                            newStr += this.getAbstract(arg);
                        }
                        break;
                    case 'o':
                        if ((0, isEl_1.default)(arg)) {
                            newStr += this.formatEl(arg);
                        }
                        else if ((0, isObj_1.default)(arg)) {
                            newStr += this.getAbstract(arg);
                        }
                        break;
                    case 'c':
                        if (str.length <= i + 1) {
                            break;
                        }
                        if (isInCss)
                            newStr += '</span>';
                        isInCss = true;
                        newStr += "<span style=\"".concat(correctStyle(arg), "\">");
                        break;
                    default:
                        i--;
                        args.unshift(arg);
                        newStr += c;
                }
            }
            else {
                newStr += c;
            }
        }
        if (isInCss)
            newStr += '</span>';
        args.unshift(newStr);
        return args;
    };
    Log.prototype.formatJs = function (val) {
        return "<pre class=\"".concat(this.console.c('code'), "\">").concat(this.console.c((0, highlight_1.default)(val, 'js', emptyHighlightStyle)), "</pre>");
    };
    Log.prototype.formatFn = function (val) {
        return "<pre style=\"display:inline\">".concat(this.formatJs(val.toString()), "</pre>");
    };
    Log.prototype.formatObj = function (val) {
        var type = (0, util_1.getObjType)(val);
        if (type === 'Array' && val.length > 1)
            type = "(".concat(val.length, ")");
        return "".concat(type, " ").concat(this.getAbstract(val));
    };
    Log.prototype.formatEl = function (val) {
        var c = this.console.c;
        return "<pre class=\"".concat(c('code'), "\">").concat(c((0, highlight_1.default)(val.outerHTML, 'html', emptyHighlightStyle)), "</pre>");
    };
    return Log;
}(Emitter_1.default));
exports.default = Log;
function correctStyle(val) {
    val = (0, lowerCase_1.default)(val);
    var rules = val.split(';');
    var style = {};
    (0, each_1.default)(rules, function (rule) {
        if (!(0, contain_1.default)(rule, ':'))
            return;
        var _a = __read(rule.split(':'), 2), name = _a[0], val = _a[1];
        style[(0, trim_1.default)(name)] = (0, trim_1.default)(val);
    });
    style['display'] = 'inline-block';
    style['max-width'] = '100%';
    delete style.width;
    delete style.height;
    var ret = '';
    (0, each_1.default)(style, function (val, key) {
        ret += "".concat(key, ":").concat(val, ";");
    });
    return ret;
}
function stringify(obj, options, cb) {
    var result = (0, stringifyAll_1.default)(obj, options);
    (0, nextTick_1.default)(function () { return cb(result); });
}
var templateObject_1;
